import styled from 'styled-components';
import { config } from '../../../../../components/dashboards/config';

export default styled.div`
  display: flex;
  background: ${config.DASHBOARD_BACKGROUND};
  flex-direction: column;
  justify-content: flex-start;
  display: flex;
  flex-direction: column;

  .dashboard-content {
    padding: 0 var(--size-lg) 42px var(--size-lg);
    overflow: auto;

    &.p-0 {
      padding: 0;
    }

    &.project-dashboard {
      padding: 0;
    }

    .clear-filters {
      display: flex;
      cursor: pointer;

      div {
        display: flex;
        flex-direction: column;
        justify-content: center;

        .clear-filters-span {
          margin-left: 6px;
          margin-right: 12px;
          color: var(--mmt-primary-70);
          text-decoration: underline;
          font-size: 13px;
        }

        .close-icon {
          font-size: 10px;
          color: var(--mmt-primary-70);
        }
      }
    }

    .dashboard-header {
      display: flex;

      .cont {
        display: flex;
        flex-direction: column;
        justify-content: center;
      
        label {
          margin-bottom: 0px;
          margin-right: 12px;
        }
      }

      .blue-title {
        font-size: var(--size-lg);
        font-family: SF UI Display;
        font-weight: 600;
        line-height: 22px;
        color: var(--mmt-primary-70);
      }

      .main {
        flex: 1
      }
    }
    
    .ant-divider-horizontal.ant-divider-with-text-left::after {
      top: 0%;
    }

    .ant-divider {
      font-size: 18px;
      font-weight: 600;
      font-family: SF UI Display;
      line-height: 22px;
      color: #595959;
      position: relative;
      margin-top: 42px;
      
      &::before {
        display: none;
      }
      
      span {
        padding-left: 0;
      }
      
      &::after {
        border-top: 2px solid ${config.BORDER_COLOR};
      }
    }

    section {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      margin: var(--size-lg) 0 0 0;
      
      .sider {
        width: 35%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        > div:not(:last-of-type) {
          margin-bottom: 20px;
        }

        &.width-350 {
          width: 350px;
        }
      }

      .main {
        width: -webkit-fill-available;
        height: unset;
        display: flex;

        > div:last-of-type {
          margin-left: 20px;
        }
      }
    }

    .multi-section {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      
      .section-col {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-width: 100px;

        .main {
          gap: 20px;

          > div:last-of-type {
            margin-left: 0px;
          }
        }
      }
    }

    .divider-with-btn {
      display: flex;

      .main-container {
        flex: 1;
      }
    }

    .ellipsis-span {
      width: 100%;
    }

    .name-span {
      text-decoration: underline;
    }

    .text-light-blue {
      color: var(--mmt-primary-70);
    }

    .ant-select-single.ant-select-show-arrow .ant-select-selection-item, 
    .ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder {
      text-align: left;
    }

    .flex-row {
      display: flex;
    }

    .flex-1 {
      flex: 1;
    }

    .flex-c {
      display: flex;
      flex-direction: column;
    }

    .jus-c {
      justify-content: center;
    }

    .hover-icon {
      color: #667085;
      transition: .4s color;

      &::hover {
        color: #1D2939;
      }
    }

    .gray-btn {
      border: 0px;
      background: #F5F5F5;
    }

    .col-section {
      display: flex;
      flex-direction: column;
      gap: var(--size-lg);
    }

    .row-section {
      display: flex;
      gap: var(--size-lg);
    }
  }
`;

export const PopoverContent = styled.div`
  h2 {
    color: #101828;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 4px;
  }

  p {
    margin-bottom: 0px;
    color: #667085; 
    font-size: 14px;
    font-weight: 400;
    width: 332px;
  }

  a {
    color: var(--mmt-primary-70);
    font-size: 14px;
    font-weight: 500;
    margin-top: 4px;
    text-decoration: none;
  }
`;
